import ErrorBox from '@components/common/ErrorBox';
import { AccordionStepsActionTypes } from '@state/features/common.types';
import Button from '@stone/ui/button/Button';
import SubmitButton from '@stone/ui/button/SubmitButton';
import Loading from '@ui/loading/Loading';
// import analytics from '@utils/analytics';
import api from '@utils/api';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
const AftercareStep5 = (props) => {
    const { t } = useTranslation();
    const [errors, setErrors] = React.useState([]);
    const [submitting, setSubmitting] = React.useState(false);
    const submit = () => {
        setErrors([]);
        setSubmitting(true);
        return api
            .aftercareSubmit()
            .then((data) => {
            setSubmitting(false);
            if (data.success) {
                props.onSubmit(data);
            }
            if (data.error && data.error.length > 0) {
                setErrors(data.error);
            }
            // analytics.aftercareFive();
        })
            .catch((e) => setErrors([e]));
    };
    const dispatch = useDispatch();
    const handleGoBack = () => {
        dispatch({
            type: AccordionStepsActionTypes.NAVIGATE_STEP,
            payload: 'images',
        });
        // analytics.aftercareBackEdit('review your request', 'back');
    };
    return (React.createElement("div", { className: "aftercare__form" },
        React.createElement("div", { className: "row aftercare__form-btn-container " },
            React.createElement("div", { className: "col-lg-12 " },
                React.createElement(Button, { type: "button", cls: ['button--quaternary'], onClick: handleGoBack },
                    React.createElement(React.Fragment, null,
                        "< ",
                        t('button.back')))),
            React.createElement("div", { className: "col-lg-12" },
                React.createElement(SubmitButton, { submitting: submitting, label: t('aftercare.sendyourrequest'), fullWidth: true, onClick: () => submit() }),
                submitting && React.createElement(Loading, null))),
        React.createElement(ErrorBox, { errors: errors })));
};
export default AftercareStep5;
